import {
  CREATEFRONTOFFICEPOSTALID,
  GETALLFRONTOFFICEPOSTALID,
  GETBYFRONTOFFICEPOSTALID ,
  UPDATEFRONTOFFICEPOSTALID,
  DELETEFRONTOFFICEPOSTALID,
} from "../actions/types";

const initialState = {
  frontofficepostalList: [],
   selectedPostalDetail: null,
};

export default function setupfrontofficepostalinwardoutwardReducer(state = initialState, action) {
  switch (action.type) {

    case CREATEFRONTOFFICEPOSTALID:
      return {
        ...state,
        postalSaveStatus: action.payload.success,
      };

    case GETBYFRONTOFFICEPOSTALID:        
      return { ...state, selectedPostalDetail: action.payload };
    case GETALLFRONTOFFICEPOSTALID:
      return {
        ...state,
        frontofficepostalList: action.payload.data,
      };

    case UPDATEFRONTOFFICEPOSTALID:
      return {
        ...state,
        postalUpdateStatus: action.payload.success,
      };

    case DELETEFRONTOFFICEPOSTALID:
      return {
        ...state,
        frontofficepostalList: state.frontofficepostalList.filter(
          (item) => item.id !== action.postalId
        ),
        postalDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}